import AbstractForm from '@/zenky/forms/AbstractForm';
import ResourceItem from '@/components/resources/ResourceItem';
import FormSubmitter from '@/zenky/forms/FormSubmitter';
import { randomId } from '@/helpers';

export default class EditResourceItem extends ResourceItem {
  protected form: AbstractForm | null = null;
  protected formId: string = '';
  protected submitter: FormSubmitter | null = null;
  protected sidebar: any = {
    exists: false,
    title: '',
    component: null,
    props: {},
  };

  get hasForm() {
    return !!this.form;
  }

  initializeItem(id: string | null = null) {
    console.log('[EditResourceItem@initializeItem] Initializing item.');

    this.loadItem(id)
      .then(() => this.createForm())
      .catch(() => {});
  }

  protected createForm() {
    if (!this.item || !this.item.id) {
      console.log('[EditResourceItem@createForm] Unable to create form because item is empty.', {
        item: this.item,
      });

      return;
    }

    this.formId = randomId('edit-form');
    this.form = this.resourceProxy.getEditForm(this.item);
    this.submitter = this.resourceProxy.getEditFormSubmitter(this.item);

    this.createSidebar();
  }

  protected createSidebar() {
    this.sidebar.exists = false;
    this.sidebar.component = null;
    this.sidebar.props = {};
    this.sidebar.title = '';

    const sidebar = this.resourceProxy.getSidebar(this.item);

    if (sidebar === null) {
      return;
    }

    this.sidebar.component = sidebar.getComponentName();
    this.sidebar.props = sidebar.getComponentProps();
    this.sidebar.title = sidebar.getTitle();
    this.sidebar.exists = true;
  }
}
